
<div class="bg-[#0e365a]">
    <!-- Filtros -->
    <div class="p-4  md:gap-4">
        <label class="block mb-2 text-white headline-05 md:mb-0">Filtra por:</label>
        <div class="flex flex-nowrap md:items-center md:justify-start button-medium gap-2">
            <select class="bg-[#D9E7F3] flex-1 min-w-0 md:flex-none md:w-[180px] px-1 md:px-2 py-1 rounded-md text-xs md:text-sm" 
                    [(ngModel)]="selectedMarca" 
                    (change)="onFilterChange()">
                <option value="">Marca</option>
                <option *ngFor="let marca of todasLasMarcas" [value]="marca.id_marca">{{ marca.nombre_marca }}</option>
            </select>

            <select class="bg-[#D9E7F3] flex-1 min-w-0 md:flex-none md:w-[180px] px-1 md:px-2 py-1 rounded-md text-xs md:text-sm" 
                    [(ngModel)]="selectedEstado" 
                    (change)="onFilterChange()">
                <option value="">Estado</option>
                <option *ngFor="let estado of estados" [value]="estado.valor">{{ estado.estado }}</option>
            </select>

            <select class="bg-[#D9E7F3] flex-1 min-w-0 md:flex-none md:w-[180px] px-1 md:px-2 py-1 rounded-md text-xs md:text-sm" 
                    [(ngModel)]="selectedCategoria" 
                    (change)="onFilterChange()">
                <option value="">Categoría</option>
                <option *ngFor="let categoria of categorias" [value]="categoria.id_categoria">{{ categoria.nombre_categoria }}</option>
            </select>

        </div>
    </div>

    <!-- Resultados de búsqueda -->
    <div *ngIf="isFiltered" class="px-4">
        <div class="pb-2 flex items-center justify-between my-3">
            <div>
                <h2 class="text-white headline-06 flex items-center gap-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>
                    </svg>
                    Resultados de búsqueda
                </h2>
                <p class="paragraph-default text-white/70">{{ searchResults.length }} resultados encontrados</p>
            </div>
        </div>
        
        <div class="carousel-container">
            <!-- Flecha izquierda -->
            <button 
              class="nav-arrow nav-arrow-left" 
              (click)="scrollSearchLeft()" 
              [disabled]="!canScrollSearchLeft"
              [class.disabled]="!canScrollSearchLeft">
              <mat-icon>chevron_left</mat-icon>
            </button>

            <!-- Contenedor de cards -->
            <div class="px-4 pb-6 overflow-x-auto overflow-y-hidden scrollbar-hide" #searchContainer>
                <div class="flex gap-4 w-max">
                    <app-benefist-card 
                        *ngFor="let marca of searchResults" 
                        [nombre]="marca.nombre_marca" 
                        [descripcion]="marca.promo_marca"
                        [imagen]="marca.imagen_marca"
                        [idMarca]="marca.id_marca">
                    </app-benefist-card>
                </div>
            </div>

            <!-- Flecha derecha -->
            <button 
              class="nav-arrow nav-arrow-right" 
              (click)="scrollSearchRight()" 
              [disabled]="!canScrollSearchRight"
              [class.disabled]="!canScrollSearchRight">
              <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
        
        <!-- Mensaje cuando no hay resultados -->
        <div *ngIf="searchResults.length === 0" class="text-center text-white py-8">
            <p class="text-lg">No se encontraron resultados con los filtros seleccionados</p>
        </div>
    </div>

    <!-- Vista por categorías (cuando no hay filtros) -->
    <div *ngIf="!isFiltered">
        <!-- Salud / Belleza -->
        <div class="px-4 pb-2 flex items-center justify-between my-3">
            <div>
                <h2 class="text-white headline-06 flex items-center gap-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14 4.14 5.57 2 7.71 3.43 9.14 2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22 14.86 20.57 16.29 22 17.71 20.57 20.57 17.71 22 16.29 20.57 14.86Z" fill="currentColor"/>
                    </svg>
                    Salud / Belleza
                </h2>
                <p class="paragraph-default text-white/70">Encuentra beneficios en lo que más te importa.</p>
            </div>
        </div>

        <div class="carousel-container">
            <!-- Flecha izquierda -->
            <button 
              class="nav-arrow nav-arrow-left" 
              (click)="scrollSaludLeft()" 
              [disabled]="!canScrollSaludLeft"
              [class.disabled]="!canScrollSaludLeft">
              <mat-icon>chevron_left</mat-icon>
            </button>

            <!-- Contenedor de cards -->
            <div class="px-4 pb-6 overflow-x-auto overflow-y-hidden scrollbar-hide" #saludContainer>
                <div class="flex gap-4 w-max">
                    <app-benefist-card 
                        *ngFor="let marca of saludBellezaMarcas" 
                        [nombre]="marca.nombre_marca" 
                        [descripcion]="marca.promo_marca"
                        [imagen]="marca.imagen_marca"
                        [idMarca]="marca.id_marca">
                    </app-benefist-card>
                </div>
            </div>

            <!-- Flecha derecha -->
            <button 
              class="nav-arrow nav-arrow-right" 
              (click)="scrollSaludRight()" 
              [disabled]="!canScrollSaludRight"
              [class.disabled]="!canScrollSaludRight">
              <mat-icon>chevron_right</mat-icon>
            </button>
        </div>

        <!-- Comercio / Servicios -->
        <div>
            <div class="px-4 pb-2 flex items-center justify-between my-3">
                <div>
                    <h2 class="text-white headline-06 flex items-center gap-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM10 6a2 2 0 0 1 4 0v1h-4V6zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2v10z" fill="currentColor"/>
                        </svg>
                        Comercio / Servicios
                    </h2>
                    <p class="paragraph-default text-white/70">Aprovecha promociones en comercios participantes.</p>
                </div>
            </div>

            <!-- Tarjetas -->
            <div class="carousel-container">
                <!-- Flecha izquierda -->
                <button 
                  class="nav-arrow nav-arrow-left" 
                  (click)="scrollComercioLeft()" 
                  [disabled]="!canScrollComercioLeft"
                  [class.disabled]="!canScrollComercioLeft">
                  <mat-icon>chevron_left</mat-icon>
                </button>

                <!-- Contenedor de cards -->
                <div class="px-4 pb-6 overflow-x-auto overflow-y-hidden whitespace-nowrap scrollbar-hide" #comercioContainer>
                    <div class="flex gap-4 w-max">
                        <app-benefist-card 
                            *ngFor="let marca of comercioServiciosMarcas" 
                            [nombre]="marca.nombre_marca" 
                            [descripcion]="marca.promo_marca"
                            [imagen]="marca.imagen_marca"
                            [idMarca]="marca.id_marca">
                        </app-benefist-card>
                    </div>
                </div>

                <!-- Flecha derecha -->
                <button 
                  class="nav-arrow nav-arrow-right" 
                  (click)="scrollComercioRight()" 
                  [disabled]="!canScrollComercioRight"
                  [class.disabled]="!canScrollComercioRight">
                  <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>

        <!-- Promociones -->
        <div>
            <div class="px-4 pb-2 flex items-center justify-between my-3">
                <div>
                    <h2 class="text-white headline-06 flex items-center gap-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 7A1.5 1.5 0 0 1 4 5.5A1.5 1.5 0 0 1 5.5 4A1.5 1.5 0 0 1 7 5.5A1.5 1.5 0 0 1 5.5 7M21.41 11.58L12.41 2.58A2 2 0 0 0 11 2H4A2 2 0 0 0 2 4V11A2 2 0 0 0 2.59 12.42L11.59 21.42A2 2 0 0 0 13 22A2 2 0 0 0 14.41 21.41L21.41 14.41A2 2 0 0 0 22 13A2 2 0 0 0 21.41 11.58Z" fill="currentColor"/>
                        </svg>
                        Promociones
                    </h2>
                    <p class="paragraph-default text-white/70">Encuentra los mejores descuentos para ti.</p>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <app-coupon-card 
                *ngFor="let marca of displayedPromociones" 
                [logo]="marca.logo_marca" 
                [descripcion]="marca.promo_marca" 
                [nombreMarca]="marca.nombre_marca" 
                [fechaValidez]="marca.vigencia_marca"
                [idMarca]="marca.id_marca">
            </app-coupon-card>
        </div>

        <!-- Botón para mostrar más cupones -->
        <div *ngIf="promociones.length > 6" class="flex justify-center mt-4">
            <button 
                (click)="toggleShowAllCoupons()" 
                class="bg-transparent border-none text-white p-2 rounded-full hover:bg-white/10 transition-colors">
                <mat-icon class="text-3xl">{{ showAllCoupons ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            </button>
        </div>
    </div>

    <div>
        <p>.</p>
    </div>
</div>